const map = [
  'null',
  'default',
  'map-navigation',
  'clustered-marker',
  'active-marker',
  'map-overlay',
  'overlay',
] as const;

export const zIndex = (name: (typeof map)[number]): number =>
  map.findIndex((itemName) => itemName === name);
